import { completedMentionParts } from "./completedMentionParts";

/** An unfinished mention at the caret. A committed (gold) mention ends its
 * search even when more text follows it; only a new @ starts another one. */
export function mentionFragment(value: string, caret: number, completed: string[]) {
  const at = value.lastIndexOf("@", caret - 1);
  if (at < 0 || caret <= at || (at > 0 && !/\s/.test(value[at - 1]!))) return null;
  const query = value.slice(at + 1, caret);
  if (/[\r\n]/.test(query)) return null;

  // Use the same boundaries as the display so a gold mention cannot also be
  // an active directory query, including when the caret moves back into it.
  let offset = 0;
  for (const part of completedMentionParts(value, completed)) {
    if (part.selected && offset === at) return null;
    offset += part.text.length;
  }
  return { at, query };
}
